import { render, staticRenderFns } from "./CbxGender.vue?vue&type=template&id=1753263b&"
import script from "./CbxGender.vue?vue&type=script&lang=ts&"
export * from "./CbxGender.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports